/** eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { EventEmitter, Input, Output } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { Notification, NotificationType } from '../../model/notification';

@Component( {
    selector: 'his-simple-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class NotificationComponent implements OnInit {
    @Input() notification: Notification;

    @Output()
        closed: EventEmitter<Notification> = new EventEmitter<Notification>();


    timer: Observable<number>;
    timerSubscription: Subscription;

    // eslint-disable-next-line @typescript-eslint/naming-convention
    NotificationType = NotificationType;

    constructor() { }

    ngOnInit() {
        this.notification.visible = true;
        this.startTimeOut();
    }

    hideNotification() {
        console.log('hideNotification 222221a');
	    this.notification.visible = false;
    }

    startTimeOut() {
        if ( this.notification.timeOut && this.notification.state === 'new' ) {
            window.setTimeout(
                () => {
                    console.log( 'timer' );
                    this.hideNotification();
                },
                this.notification.timeOut
            );
        }
    }

    onAnimationEnd() {
        if (!this.notification.visible) {
	        setTimeout( () => {
	            this.closed.emit(this.notification);
	        } );
        }
    }

    // If the notification is present for the first time
    firstTime(): boolean {
        return this.notification.state === 'new';
    }

    /**
     * Listen to keyboard events and hide all notifications if "Escape" has been pressed.
     *
     * @param event pressed key event
     */
    @HostListener( 'document:keydown', ['$event'] )
    public handleKeyboardEvent( event: KeyboardEvent ): void {
        event.stopPropagation();
        if ( event.key === 'Escape' ) {
            this.hideNotification();
        }
    }
}
